// extracted by mini-css-extract-plugin
export default {"placeholderInput":"lv1AiY","breedsInput":"kI1dFd","addBreedButtons":"Jo3NkN","wrapper":"rLz22q"};